var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgTradeLicense = function SvgTradeLicense(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E1538",
    d: "M46.5 26C52.851 26 58 31.149 58 37.5c0 3.413-1.486 6.478-3.847 8.584l1.8 14.528a2.86 2.86 0 0 1-1.517 3.057 2.942 2.942 0 0 1-3.404-.504l-4.53-4.424-4.531 4.424a2.957 2.957 0 0 1-3.4.513c-1.14-.585-1.759-1.827-1.53-3.008l1.805-14.584A11.47 11.47 0 0 1 35 37.5C35 31.149 40.149 26 46.5 26zm5.805 21.43A11.447 11.447 0 0 1 46.5 49c-2.118 0-4.101-.571-5.805-1.569l-1.68 13.55a.85.85 0 0 0 .466.916.956.956 0 0 0 1.092-.163l5.23-5.106a1 1 0 0 1 1.397 0l5.23 5.106a.945.945 0 0 0 1.092.156c.344-.175.532-.552.456-.974zM46.5 28a9.5 9.5 0 0 0-9.5 9.5c0 5.252 4.25 9.5 9.5 9.5a9.5 9.5 0 0 0 9.5-9.5 9.5 9.5 0 0 0-9.5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3A3A",
    fillRule: "nonzero",
    d: "M27.36 53H10.27C8.456 53 7 51.611 7 49.925V5.075C7 3.39 8.455 2 10.27 2h30.278c.875 0 1.717.332 2.336.917l8.178 7.804A2.98 2.98 0 0 1 52 12.882v8.509a1 1 0 0 0 2 0v-8.509a4.98 4.98 0 0 0-1.557-3.608L44.26 1.467A5.411 5.411 0 0 0 40.548 0H10.27C7.37 0 5 2.263 5 5.075v44.85C5 52.737 7.371 55 10.27 55h17.09a1 1 0 0 0 0-2z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTradeLicense, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trade-license.8dcfae82.svg";
export { ForwardRef as ReactComponent };